// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__N1Ywm","footer":"ChangeClinic_footer__146-9"};